<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <AppHeader />

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- Banner区域 -->
      <div class="banner">
        <div class="banner-background">
          <div class="city-skyline">
            <img :src="require('@/images/chb8.png')" alt="城市天际线" class="skyline-image">
          </div>
        </div>
        <div class="banner-content">
          <!-- <div class="banner-text">
            <div class="banner-title">
              <span class="blue">E企</span><span class="orange">出发</span>
              <span class="orange">逐阔天元</span>
            </div>
            <div class="banner-subtitle">助力企业扬帆出海，开拓全球市场</div>
          </div> -->
          <!-- <div class="banner-elements">
            <div class="floating-element element-1">
              <img :src="require('@/images/chb2.png')" alt="服务图标">
            </div>
            <div class="floating-element element-2">
              <img :src="require('@/images/chb3.png')" alt="服务图标">
            </div>
            <div class="floating-element element-3">
              <img :src="require('@/images/chb4.png')" alt="服务图标">
            </div>
          </div> -->
        </div>
      </div>

      <!-- 出海一件事区域 -->
      <div class="section going-global">
        <div class="section-header">
          <h2 class="section-title">出海一件事</h2>
          <div class="section-subtitle">GOING GLOBAL</div>
          <a href="#" class="more-link"><span class="more-text">查看更多</span> <span class="arrow">→</span></a>
        </div>

        <!-- 服务卡片轮播区域 -->
        <div class="service-carousel-container">
          <div class="service-carousel-inner">
            <div class="service-carousel-wrapper" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
              <div class="service-cards" v-for="(page, pageIndex) in serviceCardPages" :key="'page-' + pageIndex">
                <div class="card-wrapper" v-for="(service, index) in page" :key="index">
                  <div class="card" @click="navigateToService(service.route)">
                    <div class="card-content">
                      <img :src="service.icon" :alt="service.title" class="card-icon">
                      <div class="card-title">{{ service.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 导航箭头 -->
          <div class="nav-arrows">
            <div class="arrow-left" @click="prevSlide">←</div>
            <div class="arrow-right" @click="nextSlide">→</div>
          </div>
          
          <!-- 轮播指示器 -->
          <div class="carousel-indicators">
            <div 
              class="indicator" 
              v-for="(page, index) in serviceCardPages" 
              :key="index" 
              :class="{ active: currentSlide === index }"
              @click="goToSlide(index)"
            ></div>
          </div>
        </div>
      </div>
      
      <!-- 政策资讯和活动发布区域 -->
      <div class="section info-activity">
        <div class="info-activity-container">
          <!-- 政策资讯模块 -->
          <div class="info-module">
            <div class="module-header">
              <div class="header-content">
                <div class="title-section">
                  <h3 class="module-title">政策资讯</h3>
                  <div class="module-subtitle">POLICY INFORMATION</div>
                </div>
                <router-link to="/policy-info" class="more-link">
                  <span class="more-text">查看更多</span> 
                  <span class="arrow">→</span>
                </router-link>
              </div>
            </div>
            <div class="info-list">
              <div class="info-item" v-for="(policy, index) in policyList" :key="index" @click="handlePolicyClick(policy)" style="cursor: pointer;">
                <div class="info-date">
                  <div class="date-day">{{ policy.day }}</div>
                  <div class="date-month">{{ policy.month }}</div>
                </div>
                <div class="info-content">
                  <h4 class="info-title">{{ policy.title }}</h4>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 活动发布模块 -->
          <div class="activity-module">
            <div class="module-header">
              <div class="header-content">
                <div class="title-section">
                  <h3 class="module-title">活动发布</h3>
                  <div class="module-subtitle">EVENT RELEASE</div>
                </div>
                <router-link to="/activity-publish" class="more-link">
                  <span class="more-text">查看更多</span> 
                  <span class="arrow">→</span>
                </router-link>
              </div>
            </div>
            <div class="activity-list">
              <div class="activity-item" v-for="(activity, index) in activityList" :key="index" @click="navigateToActivityReview">
                <div class="activity-content">
                  <h4 class="activity-title">{{ activity.title }}</h4>
                  <div class="activity-time">开始时间：{{ activity.startTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="resource-img">
        <img :src="require('@/images/chb21.png')" alt="">
      </div>
      <!-- 资源分布图区域 -->
      <div class="section resource-map">
          <div style="height: 20px;"></div>
          <div class="procedure-box">
            <div class="procedure-item pro-img-one">出海前</div>
            <div class="procedure-item pro-img-tow">出海中</div>
            <div class="procedure-item pro-img-there">出海后</div>
          </div>
          <div class="procedure-xian-box">
            <div class="xian-box xian-img1"></div>
            <div class="xian-box xian-img2"></div>
            <div class="xian-box xian-img3"></div>
          </div>
          <div class="procedure-title-box">
            <div class="procedure-title-items">
              <div class="procedure-title-nr title-nr1" @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/marketAnalysis/marketAnalysis')" style="cursor: pointer;">
                <div class="text-num-box">1</div>
                <div class="text-box">市场分析</div>
              </div>
              <div class="procedure-title-nr title-nr1 mgf20px" @click="navigateToService('/exhibition-info')" style="cursor: pointer;">
                <div class="text-num-box">2</div>
                <div class="text-box">展会信息</div>
              </div>
            </div>
            <div class="procedure-title-items">
                <div class="procedure-title-nr title-nr2">
                <div class="text-num-box">3</div>
                <div class="text-box">选择专业服务</div>
              </div>
              <div class="procedure-title-nr title-nr2 mgf20px">
                <div class="text-num-box">4</div>
                <div class="text-box">手续办理</div>
              </div>
            </div>
            <div class="procedure-title-items">
                <div class="procedure-title-nr title-nr3">
                <div class="text-num-box">5</div>
                <div class="text-box">售后服务</div>
              </div>
              <div class="procedure-title-nr title-nr3 mgf20px">
                <div class="text-num-box">6</div>
                <div class="text-box" @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/settlement/settlement')" style="cursor: pointer;">结汇退税</div>
              </div>
            </div>
          </div>

          <div class="procedure-title-box">
            <div class="procedure-title-items">
            </div>
            <div class="procedure-title-items">

              <div class="items-box items-img1-box" @click="navigateToService('/one-stop-service')" style="cursor: pointer;">咨询服务</div>
              <div class="items-box items-img1-box mgl61" @click="navigateToService('/nuclear-business-scope')" style="cursor: pointer;">核营范围</div>
            </div>
            <div class="procedure-title-items">
              <div class="items-box items-img2-box" @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/storehouse/storehouse')" style="cursor: pointer;">海外仓</div>
            </div>
          </div>
          <div class="procedure-title-box">
            <div class="procedure-title-items">
            </div>
            <div class="procedure-title-items">

              <div class="items-box items-img1-box" @click="navigateToService('/agent-service')" style="cursor: pointer;">代理服务</div>
              <div class="items-box items-img1-box mgl61"  @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/customs/customs')" style="cursor: pointer;">海关备案</div>
            </div>
            <div class="procedure-title-items">
              <div class="items-box items-img2-box"  @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/storehouseNext/storehouseNext')" style="cursor: pointer;">海外服务<br>中心链接</div>
              <div class="items-box mgl61"></div>
            </div>
          </div>
          <div class="procedure-title-box">
            <div class="procedure-title-items">
            </div>
            <div class="procedure-title-items">

              <div class="items-box items-img1-box" @click="navigateToService('/custom-service')" style="cursor: pointer;">定制服务</div>
              <div class="items-box items-img1-box mgl61" @click="goToExternalPage('https://chb.hnjsxk.com/app/#/pages/smartcard/smartcard')" style="cursor: pointer;">IC卡申领</div>
            </div>
            <div class="procedure-title-items">

            </div>
          </div>
          <div class="procedure-title-box">
            <div class="procedure-title-items">
                
            </div>
            <div class="procedure-title-items">
              <div class="items-box items-img1-box" @click="navigateToService('/financial-service')" style="cursor: pointer;">金融服务</div>
              <div class="items-box items-img1-box mgl61" @click="navigateToService('/foreign-exchange-account')" style="cursor: pointer;">外汇开户</div>
            </div>
            <div class="procedure-title-items">

            </div>
          </div>
          <div class="procedure-title-box">
            <div class="procedure-title-items">
                
            </div>
            <div class="procedure-title-items">
              <div class="items-box items-img1-box" @click="navigateToService('/legal-service')" style="cursor: pointer;">法律服务</div>
              <div class="items-box items-img1-box mgl61" @click="navigateToService('/tax-registration')" style="cursor: pointer;">税务登记</div>
            </div>
            <div class="procedure-title-items">

            </div>
          </div>

      </div>
    </div>

    <!-- 底部区域 -->
    <AppFooter />
    
    <!-- 右侧固定元素 -->
    <div class="fixed-sidebar" @click="showModal = true" @mouseenter="handleSidebarMouseEnter" @mouseleave="handleSidebarMouseLeave">
      <div class="finger-pointer">
        <img :src="require('@/images/moimg.jpg')" alt="点击手指" class="finger-img">
      </div>
      
      <!-- <div class="sidebar-content">
        <img :src="require('@/images/chb20.png')" alt="企业出海" class="sidebar-bg">
        <div class="sidebar-text">
          <div class="text-line1">企业出海</div>
          <div class="text-line2">一键护航</div>
          <div class="text-line3">提交需求</div>
        </div>
        <div class="finger-pointer">
          <img :src="require('@/images/chb18.png')" alt="点击手指" class="finger-img">
        </div>
      </div> -->
    </div>

    <!-- 手机端码固定元素 -->
    <div class="mini-program-qr">
      <div class="qr-container">
        <div class="qr-header">手机端</div>
        <div class="qr-code">
          <img :src="require('@/images/erwm.jpg')" alt="手机端二维码" class="qr-image">
        </div>
      </div>
    </div>

    <!-- 提交需求模态框 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>提交需求</h3>
          <button class="close-btn" @click="closeModal">×</button>
        </div>
        <el-form class="modal-form" :model="formData" :rules="formRules" ref="submitForm" @submit.native.prevent="submitForm">
          <el-form-item label="企业名称" prop="companyName" required>
            <el-input 
              v-model="formData.companyName" 
              placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业需求" prop="companyDescription" required>
            <el-input 
              type="textarea"
              v-model="formData.companyDescription" 
              placeholder="请输入企业需求"
              :rows="4"
              maxlength="240"
              show-word-limit
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业负责人" prop="contactPerson" required>
            <el-input 
              v-model="formData.contactPerson" 
              placeholder="请输入企业负责人"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="联系方式" prop="contactPhone" required>
            <el-input 
              v-model="formData.contactPhone" 
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          
          <div class="form-footer">
             <div class="service-phone">
               服务热线电话：0731-28666027
             </div>
             <div class="form-buttons">
               <el-button @click="closeModal">取消</el-button>
               <el-button type="primary" @click="submitForm">提交</el-button>
             </div>
           </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import api from '@/utils/api'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      // 模态框相关
      showModal: false,
      formData: {
        companyName: '',
        companyDescription: '',
        contactPerson: '',
        contactPhone: ''
      },
      formRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        companyDescription: [
          { required: true, message: '请输入企业需求', trigger: 'blur' },
          { max: 240, message: '企业需求不能超过240个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入企业负责人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      // 当前选中的出海阶段
      currentStage: '出海前',
      // 轮播相关数据
      currentSlide: 0,
      autoplayTimer: null,
      
      // 侧边栏移动轨迹相关数据
       sidebarPosition: {
         x: 50,
         y: 50
       },
       sidebarVelocity: {
         x: 2,
         y: 1.5
       },
       animationId: null,
        windowSize: {
          width: 0,
          height: 0
        },
        isAnimationPaused: false,
 
       // 服务卡片数据
      serviceCards: [
        {
          icon: require('@/images/chb22.png'),
          title: '咨询服务',
          description: '智能问答系统，快速获取出海相关信息',
          route: '/one-stop-service'
        },
        {
          icon: require('@/images/chb17.png'),
          title: '商标注册',
          description: '国际商标注册与保护服务',
          route: '/trademark-registration'
        },
        {
          icon: require('@/images/chb16.png'),
          title: '订单融资',
          description: '国际贸易订单管理与商品展示',
          route: '/order-financing'
        },
        {
          icon: require('@/images/chb19.png'),
          title: '信用保险',
          description: '企业国际信用评估与认证',
          route: '/credit-insurance'
        },
        {
          icon: require('@/images/chb23.png'),
          title: '资信调查',
          description: '海外企业资信调查服务',
          route: '/credit-investigation'
        },
        {
          icon: require('@/images/chb9.png'),
          title: '国际储运',
          description: '全球物流解决方案',
          route: '/international-storage'
        },
        {
          icon: require('@/images/chb24.png'),
          title: '租船订舱',
          description: '国际海运订舱服务',
          route: '/ship-booking'
        },
        {
          icon: require('@/images/chb7.png'),
          title: '单证服务',
          description: '进出口报关报检一站式服务',
          route: '/document-service'
        }, 
        
        {
          icon: require('@/images/ysbx.png'),
          title: '运输保险',
          description: '智能问答系统，快速获取出海相关信息',
          route: '/transport-insurance'
        },
        {
          icon: require('@/images/kjds.png'),
          title: '跨境电商',
          description: '国际商标注册与保护服务',
          route: '/cross-border-ecommerce'
        },
        {
          icon: require('@/images/jhsh.png'),
          title: '结汇售汇',
          description: '国际贸易订单管理与商品展示',
          route: '/foreign-exchange'
        },
        {
          icon: require('@/images/tssq.png'),
          title: '退税申请',
          description: '企业国际信用评估与认证',
          route: '/tax-refund'
        },
        {
          icon: require('@/images/zzcp.png'),
          title: '知识产权',
          description: '海外企业资信调查服务',
          route: '/intellectual-property'
        },
        {
          icon: require('@/images/flgw.png'),
          title: '法律顾问',
          description: '全球物流解决方案',
          route: '/legal-consultant'
        },
        {
          icon: require('@/images/wmdl.png'),
          title: '外贸代理',
          description: '国际海运订舱服务',
          route: '/foreign-trade-agent'
        },
        {
          icon: require('@/images/zsfw.png'),
          title: '专属服务',
          description: '进出口报关报检一站式服务',
          route: '/exclusive-service'
        },
        {
          icon: require('@/images/demy.png'),
          title: '对俄贸易',
          description: '专业的对俄贸易服务与支持',
          route: '/russian-trade'
        }
      ],
      // 政策资讯数据
      policyList: [
        {
          day: '23',
          month: '2025.05',
          title: '重大政策利好对湖南中小外贸企业，这些"第一"资口领域有福利！'
        },
        {
          day: '23',
          month: '2025.05',
          title: '@株洲企业，参与国际市场竞争中的100万元'
        },
        {
          day: '04',
          month: '2025.01',
          title: '湖南省人民政府办公厅印发《湖南省落实中央"十大政策"实施方案》'
        },
        {
          day: '31',
          month: '2025.03',
          title: '湖南省人民政府印发《中国(株洲)跨境电子商务综合试验区实施方案》'
        }
      ],
      // 活动发布数据
      activityList: [
        {
          title: '株洲企业出海实务培训——高新区专场活动',
          startTime: '2025年7月11日'
        },
        {
          title: '株洲企业出海实务培训——高新区专场活动',
          startTime: '2025年7月11日'
        },
        {
          title: '株洲企业出海实务培训——高新区专场活动',
          startTime: '2025年7月11日'
        },
        {
          title: '株洲企业出海实务培训——高新区专场活动',
          startTime: '2025年7月11日'
        }
      ],
      // 资源分布数据
      resourceCategories: [
        { name: '咨询服务', type: 'region' },
        { name: '税务范围', type: 'region' },
        { name: '金融服务', type: 'region' },
        { name: '法律服务', type: 'region' },
        { name: '海外仓', type: 'industry' },
        { name: '海关备案', type: 'industry' },
        { name: 'IC卡申领', type: 'industry' },
        { name: '外汇开户', type: 'industry' },
        { name: '税务登记', type: 'industry' },
        { name: '海外服务中心链接', type: 'region' }
      ],
      // 流程步骤
      processSteps: [
        { id: 1, name: '市场分析', stage: '出海前' },
        { id: 2, name: '服务信息', stage: '出海前' },
        { id: 3, name: '各行业服务', stage: '出海前' },
        { id: 4, name: '手续办理', stage: '出海中' },
        { id: 5, name: '智能服务', stage: '出海后' },
        { id: 6, name: '线下服务', stage: '出海后' }
      ]
    }
  },
  computed: {
    // 根据当前阶段筛选流程步骤
    filteredSteps() {
      return this.processSteps.filter(step => step.stage === this.currentStage)
    },
    // 所有流程步骤
    allProcessSteps() {
      return this.processSteps
    },
    // 将服务卡片按页分组，每页8个
    serviceCardPages() {
      const pages = [];
      const cardsPerPage = 8;
      for (let i = 0; i < this.serviceCards.length; i += cardsPerPage) {
        pages.push(this.serviceCards.slice(i, i + cardsPerPage));
      }
      return pages;
    }
  },
  async mounted() {
    // 启动自动轮播
    // this.startAutoplay();
    
    // 检查并获取token
    await this.checkAndGetToken();
    
    // 获取政策资讯数据
    await this.loadPolicyList();
    
    // 获取活动发布数据
    await this.loadActivityList();
    
    // 初始化侧边栏移动动画
    this.initSidebarAnimation();
  },
  beforeDestroy() {
    // 清除自动轮播定时器
    this.stopAutoplay();
    
    // 清除侧边栏动画
    this.stopSidebarAnimation();
    
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.handleWindowResize);
  },

  methods: {
    // 检查并获取token
    async checkAndGetToken() {
      try {
        await api.checkAndGetToken();
      } catch (error) {
        console.error('获取token失败:', error);
      }
    },
    
    // 获取政策资讯列表
    async loadPolicyList() {
      try {
        // console.log('正在获取政策资讯数据...');
        const response = await api.getPolicyList(1, 50);
        // console.log('政策资讯接口响应:', response);
        
        if (response && response.result && response.result.records) {
           // 转换数据格式以匹配模板需求，只取前4条数据
           this.policyList = response.result.records.slice(0, 4).map(item => {
             const createTime = new Date(item.createTime);
             const day = createTime.getDate().toString().padStart(2, '0');
             const month = `${createTime.getFullYear()}.${(createTime.getMonth() + 1).toString().padStart(2, '0')}`;
             
             return {
               day: day,
               month: month,
               title: item.policyIntroduce || '暂无标题',
               url: item.url || '',
               type: item.type || '',
               fileUpload: item.fileUpload || ''
             };
           });
           // console.log('政策资讯数据已更新（前4条）:', this.policyList);
         }
      } catch (error) {
        console.error('获取政策资讯失败:', error);
        // 保持使用默认的静态数据
      }
    },
     
     // 获取活动发布列表
     async loadActivityList() {
       try {
         // console.log('正在获取活动发布数据...');
         
         // 并行调用两个接口
         const [zeroResponse, oneResponse] = await Promise.all([
           api.getActivityZero(),
           api.getActivityOne()
         ]);
         
         // console.log('活动发布zero接口响应:', zeroResponse);
         // console.log('活动发布one接口响应:', oneResponse);
         
         let combinedActivities = [];
         
         // 处理zero接口数据
         if (zeroResponse && zeroResponse.result) {
           const zeroData = Array.isArray(zeroResponse.result.records) ? zeroResponse.result.records : [zeroResponse.result.records];
           combinedActivities = combinedActivities.concat(zeroData);
         }
         
         // 处理one接口数据
         if (oneResponse && oneResponse.result) {
           const oneData = Array.isArray(oneResponse.result.records) ? oneResponse.result.records : [oneResponse.result.records];
           combinedActivities = combinedActivities.concat(oneData);
         }
         
         // 转换数据格式并只取前4条
         this.activityList = combinedActivities.slice(0, 4).map(item => {
           return {
             title: item.qyTitle || '暂无标题',
             startTime: item.startTime || item.createTime || '待定时间'
           };
         });
         
         // console.log('活动发布数据已更新（前4条）:', this.activityList);
       } catch (error) {
         console.error('获取活动发布失败:', error);
         // 保持使用默认的静态数据
       }
     },
     
     // 处理政策信息点击事件
    handlePolicyClick(policy) {
	if (policy.type == '1') {
        // 如果url是完整的http/https链接，直接跳转
        if (policy.url.startsWith('http://') || policy.url.startsWith('https://')) {
          window.open(policy.url, '_blank')
        } else {
          console.log('相对路径URL:', policy.url)
        }
      } else {
		window.open(policy.fileUpload, '_blank')
      }
     },
     
     // 切换出海阶段
    changeStage(stage) {
      this.currentStage = stage
    },
    
    // 初始化侧边栏动画
    initSidebarAnimation() {
      // 获取初始窗口大小
      this.updateWindowSize();
      
      // 设置初始位置（确保在有效范围内）
      const sidebar = this.$el.querySelector('.fixed-sidebar');
      if (!sidebar) {
        // 如果sidebar还没有渲染，延迟执行
        this.$nextTick(() => {
          this.initSidebarAnimation();
        });
        return;
      }
      
      const sidebarRect = sidebar.getBoundingClientRect();
      const sidebarWidth = sidebarRect.width;
      const sidebarHeight = sidebarRect.height;
      const maxX = this.windowSize.width - sidebarWidth - 20;
      const maxY = this.windowSize.height - sidebarHeight - 20;
      const minX = 20;
      const minY = 20;
      
      // 如果初始位置超出边界，重新设置
      this.sidebarPosition.x = Math.max(minX, Math.min(maxX, this.sidebarPosition.x));
      this.sidebarPosition.y = Math.max(minY, Math.min(maxY, this.sidebarPosition.y));
      
      // 监听窗口大小变化
      window.addEventListener('resize', this.handleWindowResize);
      
      // 启动动画
      this.startSidebarAnimation();
    },
    
    // 更新窗口大小
    updateWindowSize() {
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
    },
    
    // 处理窗口大小变化
    handleWindowResize() {
      this.updateWindowSize();
      
      // 窗口大小变化时，确保侧边栏位置在有效范围内
      const sidebar = this.$el.querySelector('.fixed-sidebar');
      if (!sidebar) return;
      
      const sidebarRect = sidebar.getBoundingClientRect();
      const sidebarWidth = sidebarRect.width;
      const sidebarHeight = sidebarRect.height;
      const maxX = this.windowSize.width - sidebarWidth - 20;
      const maxY = this.windowSize.height - sidebarHeight - 20;
      const minX = 20;
      const minY = 20;
      
      // 调整位置到有效范围内
      this.sidebarPosition.x = Math.max(minX, Math.min(maxX, this.sidebarPosition.x));
      this.sidebarPosition.y = Math.max(minY, Math.min(maxY, this.sidebarPosition.y));
    },
    
    // 启动侧边栏动画
    startSidebarAnimation() {
      const animate = () => {
        this.updateSidebarPosition();
        this.animationId = requestAnimationFrame(animate);
      };
      animate();
    },
    
    // 停止侧边栏动画
    stopSidebarAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    },
    
    // 更新侧边栏位置
     updateSidebarPosition() {
       const sidebar = this.$el.querySelector('.fixed-sidebar');
       if (!sidebar) return;
       
       // 如果动画被暂停，则不更新位置
       if (this.isAnimationPaused) return;
       
       // 动态获取侧边栏的实际尺寸
       const sidebarRect = sidebar.getBoundingClientRect();
       const sidebarWidth = sidebarRect.width;
       const sidebarHeight = sidebarRect.height;
       
       // 计算边界（确保使用当前窗口大小）
       // 注意：sidebarPosition.x 表示距离左边的距离
       const maxX = this.windowSize.width - sidebarWidth - 20; // 左边距离的最大值
       const maxY = this.windowSize.height - sidebarHeight - 20;
       const minX = 20; // 左边距离的最小值
       const minY = 20;
       
       // 计算下一个位置
       let nextX = this.sidebarPosition.x + this.sidebarVelocity.x;
       let nextY = this.sidebarPosition.y + this.sidebarVelocity.y;
       
       // 检查X轴边界碰撞
       if (nextX <= minX) {
         nextX = minX;
         this.sidebarVelocity.x = Math.abs(this.sidebarVelocity.x); // 确保向右移动
       } else if (nextX >= maxX) {
         nextX = maxX;
         this.sidebarVelocity.x = -Math.abs(this.sidebarVelocity.x); // 确保向左移动
       }
       
       // 检查Y轴边界碰撞
       if (nextY <= minY) {
         nextY = minY;
         this.sidebarVelocity.y = Math.abs(this.sidebarVelocity.y); // 确保向下移动
       } else if (nextY >= maxY) {
         nextY = maxY;
         this.sidebarVelocity.y = -Math.abs(this.sidebarVelocity.y); // 确保向上移动
       }
       
       // 更新位置
       this.sidebarPosition.x = nextX;
       this.sidebarPosition.y = nextY;
       
       // 应用位置到DOM元素（使用left定位保持一致性）
       sidebar.style.left = `${this.sidebarPosition.x}px`;
       sidebar.style.top = `${this.sidebarPosition.y}px`;
       sidebar.style.right = 'auto'; // 清除right定位
       sidebar.style.transform = 'none';
     },
     
     // 鼠标进入侧边栏时暂停动画
     handleSidebarMouseEnter() {
       this.isAnimationPaused = true;
     },
     
     // 鼠标离开侧边栏时恢复动画
     handleSidebarMouseLeave() {
      this.isAnimationPaused = false
    },
    
    // 导航到活动发布页面并选中活动回顾
    navigateToActivityReview() {
      this.$router.push({
        path: '/activity-publish',
        query: { category: 'review' }
      })
    },
    // 切换到下一页
    nextSlide() {
      const totalSlides = this.serviceCardPages.length;
      this.currentSlide = (this.currentSlide + 1) % totalSlides;
    },
    // 切换到上一页
    prevSlide() {
      const totalSlides = this.serviceCardPages.length;
      this.currentSlide = (this.currentSlide - 1 + totalSlides) % totalSlides;
    },
    // 切换到指定页
    goToSlide(index) {
      this.currentSlide = index;
    },
    // 开始自动轮播
    startAutoplay() {
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, 5000); // 5秒切换一次
    },
    // 停止自动轮播
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },
    // 导航到服务页面
    navigateToService(route) {
      if (route) {
        this.$router.push(route);
      }
    },
    // 关闭模态框
    closeModal() {
      this.showModal = false
    },
    // 提交表单
    async submitForm() {
      this.$refs.submitForm.validate(async (valid) => {
        if (valid) {
          try {
            const requestData = {
              type: 1, // 咨询服务
              applicationType: 1,
              name: this.formData.companyName,
              person: this.formData.contactPerson,
              phone: this.formData.contactPhone,
              demand: this.formData.companyDescription
            };
            
            await api.submitDemand(requestData);
            
            this.$message.success('需求提交成功！我们会尽快与您联系。');
            
            // 重置表单并关闭模态框
            this.$refs.submitForm.resetFields();
            this.closeModal();
          } catch (error) {
            console.error('提交失败:', error);
            this.$message.error('提交失败，请稍后重试');
          }
        } else {
          this.$message.error('请正确填写所有必填字段');
          return false;
        }
      });
    },
    
    // 通用外部页面跳转方法
    goToExternalPage(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.home-container {
  width: 100%;
  max-width: 100vw; /* 防止水平滚动 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  background-color: white;
  padding-top: 0; /* 透明导航栏不需要预留空间 */
}

.main-content {
  width: 100%;
  position: relative;
}



/* Banner区域样式 */
.banner {
  position: relative;
  height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.clouds {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(ellipse 200px 100px at 20% 30%, rgba(255,255,255,0.8) 0%, transparent 50%),
    radial-gradient(ellipse 300px 150px at 70% 20%, rgba(255,255,255,0.6) 0%, transparent 50%),
    radial-gradient(ellipse 250px 120px at 90% 40%, rgba(255,255,255,0.7) 0%, transparent 50%),
    radial-gradient(ellipse 180px 90px at 10% 60%, rgba(255,255,255,0.5) 0%, transparent 50%);
  animation: cloudFloat 20s ease-in-out infinite;
}

@keyframes cloudFloat {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(20px); }
}

.city-skyline {
  /* position: absolute; */
  /* bottom: 0; */
  left: 0;
  width: 100%;
  height: 100%;
  /* display: flex;
  align-items: flex-end;
  justify-content: center; */
}

.skyline-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
  /* opacity: 0.8; */
}

.banner-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text {
  text-align: center;
  z-index: 3;
}

.banner-title {
  font-size: 72px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.banner-subtitle {
  font-size: 24px;
  color: #2c5aa0;
  margin-top: 20px;
  text-shadow: 0 2px 10px rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.blue {
  color: #1e50a2;
}

.orange {
  color: #ff6600;
}

.banner-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.floating-element {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  animation: float 6s ease-in-out infinite;
}

.floating-element img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.element-1 {
  top: 20%;
  left: 15%;
  animation-delay: 0s;
}

.element-2 {
  top: 30%;
  right: 20%;
  animation-delay: 2s;
}

.element-3 {
  bottom: 25%;
  left: 10%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

/* 内容区域通用样式 */
.section {
  /* padding: 50px; */
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding: 0 20px;
}

.section-title {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
  color: #fff;
  position: relative;
  padding-bottom: 10px;
  display: inline-block;
}

.section-subtitle {
  font-size: 16px;
  color: #fff;
  margin-top: 0;
  margin-bottom: 30px;
}

.more-link {
  margin-left: auto;
  text-decoration: none;
  color: #e8f4ff;
  display: flex;
  align-items: center;
  background-color: #e8f4ff;
  padding: 6px 15px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.more-link:hover {
  background-color: #1e50a2;
  color: #e8f4ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(30, 80, 162, 0.2);
}

.more-text {
  margin-right: 5px;
}

.arrow {
    font-size: 16px;
  }

  /* 服务卡片轮播区域样式 */
  .service-carousel-container {
    position: relative;
    width: 100%;
    overflow: visible;
    padding: 20px 60px;
  }

  .service-carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

.service-carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease;
}

/* 服务卡片区域样式 */
.service-cards {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 100%;
  flex-shrink: 0;
}

.card-wrapper {
  width: 25%; /* 桌面端每行4个卡片 */
  padding: 8px;
  height: 210px;
  margin-top: 16px;
  box-sizing: border-box;
  min-width: 200px; /* 确保最小宽度 */
}

.card {
  background-color: #ffffff;
  /* border-radius: 12px; */
  padding: 0;
  text-align: center;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  cursor: pointer;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  border-color: #e0e8ff;
}

.card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
}

.card-icon {
  width: 100%;
  height: calc(100% - 40px); /* 为标题留出空间 */
  transition: transform 0.3s ease;
  object-fit: cover; /* 保持比例，裁剪超出部分 */
  object-position: center; /* 图片居中显示 */
}

.card:hover .card-icon {
  transform: scale(1.02);
}

.card-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0;
  line-height: 1.2;
  text-align: left;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 12px;
  backdrop-filter: blur(2px);
  word-break: break-word; /* 防止长文本溢出 */
  /* border-top: 1px solid rgba(240, 240, 240, 0.8); */
}

/* 导航箭头样式 - 移到容器外部 */
.nav-arrows {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  left: 0;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  z-index: 3;
  padding: 0 20px;
}

.arrow-left, .arrow-right {
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  font-size: 16px;
  color: #666;
  border: 2px solid #e8f4ff;
}

.arrow-left:hover, .arrow-right:hover {
  background-color: #4285f4;
  color: white;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(66, 133, 244, 0.3);
  border-color: #4285f4;
}

/* 轮播指示器样式 - 细长矩形条状 */
.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 8px;
}

.indicator {
  width: 24px;
  height: 4px;
  border-radius: 2px;
  background-color: #d0d0d0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background-color: #4285f4;
  width: 32px;
}

.indicator:hover {
  background-color: #4285f4;
  opacity: 0.8;
}

/* 资源分布图区域样式 */
.resource-img{
  width: 100%;
  height: 220px;
  /* border: 1px red solid; */
}
.resource-img img{
  width: 100%;
  height: 100%;
}

/* 资源分布图区域样式 */
.resource-map {
  /* margin-top: 50px; */
  overflow: hidden;
}

/* 蓝色背景区域 */
.map-header {
  background: linear-gradient(135deg, #4285f4 0%, #6fa8f5 100%);
  padding: 40px 0 60px;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.map-header .section-title {
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 0;
}

/* 轮船装饰 */
.ship-decoration {
  position: absolute;
  top: 20px;
  right: 50px;
  z-index: 2;
}

.ship-img {
  width: 180px;
  height: auto;
}

/* 云朵装饰 */
.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
}

.cloud:before,
.cloud:after {
  content: '';
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
}

.cloud-1 {
  width: 40px;
  height: 15px;
  top: -30px;
  left: -80px;
  animation: float 6s ease-in-out infinite;
}

.cloud-1:before {
  width: 20px;
  height: 20px;
  top: -10px;
  left: 5px;
}

.cloud-1:after {
  width: 25px;
  height: 25px;
  top: -12px;
  right: 5px;
}

.cloud-2 {
  width: 30px;
  height: 12px;
  top: 10px;
  left: -120px;
  animation: float 8s ease-in-out infinite reverse;
}

.cloud-2:before {
  width: 15px;
  height: 15px;
  top: -8px;
  left: 3px;
}

.cloud-2:after {
  width: 18px;
  height: 18px;
  top: -10px;
  right: 3px;
}

.cloud-3 {
  width: 35px;
  height: 14px;
  top: 40px;
  left: -60px;
  animation: float 7s ease-in-out infinite;
}

.cloud-3:before {
  width: 18px;
  height: 18px;
  top: -9px;
  left: 4px;
}

.cloud-3:after {
  width: 22px;
  height: 22px;
  top: -11px;
  right: 4px;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 白色内容区域 */
.map-content {
  background: white;
  padding: 40px 20px 60px;
  text-align: center;
}

.process-flow {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
  flex-wrap: wrap;
  gap: 0;
}

/* 流程图容器 */
.process-flow-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
  gap: 20px;
  flex-wrap: wrap;
}

/* 阶段容器 */
.stage-container {
  position: relative;
  width: 200px;
  height: 120px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.stage-container:hover {
  transform: translateY(-5px);
  filter: brightness(1.1);
}

/* 阶段背景 */
.stage-background {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.stage-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 阶段内容 */
.stage-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.stage-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.stage-steps {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.step-number {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
}

.step-name {
  font-weight: 500;
  white-space: nowrap;
}

/* 连接线 */
.connection-line {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 40px;
}

.line-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.resource-categories {
  margin-top: 5px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.category-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.category-row:last-child {
  margin-bottom: 0;
}

.category {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  transition: all 0.3s ease;
  cursor: pointer;
  text-align: center;
  border: 1px solid transparent;
  min-width: 100px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.category.region {
  background-color: #FFE4B5;
  color: #8B4513;
  border-color: #DEB887;
}

.category.industry {
  background-color: #E0F2E7;
  color: #2E7D32;
  border-color: #A5D6A7;
}

/* 右侧固定侧边栏 */
.fixed-sidebar {
  position: fixed;
  width: 270px; /* 与sidebar-content保持一致 */
  height: 180px; /* 与sidebar-content保持一致 */
  z-index: 1000;
  cursor: pointer;
  transition: none;
  /* 位置由JavaScript动态控制 */
  top: 0;
  left: 0;
}

.fixed-sidebar:hover {
  transform: translateY(-50%) scale(1.05);
}

.sidebar-content {
  position: relative;
  width: 270px;
  height: 180px;
  border-radius: 30px;
  /* box-shadow: 0 8px 25px rgba(38, 142, 239, 0.907); */
  /* 核心阴影设置 */
  /* box-shadow: 6px 6px 10px -4px rgba(38, 142, 239, 0.907); */
}

.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* border-radius: 15px 0 0 15px; */
  /* box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2); */
}

.sidebar-text {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  font-weight: bold;
  margin-top: 25px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.text-line1 {
  font-size: 16px;
  margin-bottom: 2px;
  letter-spacing: 1px;
  margin-top: 10px;
}

.text-line2 {
  font-size: 16px;
  margin-bottom: 8px;
  letter-spacing: 1px;
  margin-top: 10px;
}

.text-line3 {
  width: 80%;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.9);
  color: #4A90E2;
  padding: 4px 8px;
  border-radius: 10px;
  font-weight: 600;
  margin:20px auto;
}

.finger-pointer {
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 270px;
  height: 180px;
}

.finger-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* animation: fingerTap 1.5s ease-in-out infinite; */
}

@keyframes fingerTap {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.2) rotate(-5deg);
    opacity: 0.8;
  }
}

/* 小程序码固定元素 */
.mini-program-qr {
  position: fixed;
  right: 20px;
  top: 65%;
  transform: translateY(-50%);
  z-index: 999;
  width: 120px;
  height: 150px;
}

.qr-container {
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
  border-radius: 15px;
  padding: 15px 10px;
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
  text-align: center;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.qr-container:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(255, 107, 53, 0.4);
}

.qr-header {
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.qr-code {
  background: white;
  border-radius: 8px;
  padding: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-image {
  width: 100%;
  height: auto;
  max-width: 80px;
  border-radius: 4px;
}

/* 响应式布局 */
/* 平板端适配 (768px - 1024px) */
@media (max-width: 1024px) and (min-width: 769px) {
  .banner {
    height: 500px;
  }
  
  .banner-title {
    font-size: 60px;
  }
  
  .banner-subtitle {
    font-size: 20px;
  }
  
  .service-carousel-container {
    padding: 30px 60px;
  }
  
  .card-wrapper {
    width: 33.33%; /* 平板端每行3个卡片 */
    min-width: 180px;
  }
  
  .procedure-box {
    width: 90%;
  }
  
  .procedure-xian-box {
    width: 90%;
  }
  
  .procedure-title-box {
    width: 90%;
  }
  
  .procedure-title-items {
    width: 400px;
  }
  
  .text-box {
    font-size: 18px;
  }
  
  .items-box {
    font-size: 16px;
  }
  
  /* 小程序码响应式 - 平板端 */
  .mini-program-qr {
    width: 100px;
    height: 130px;
    right: 15px;
  }
  
  .qr-header {
    font-size: 14px;
  }
  
  .qr-image {
    max-width: 70px;
  }
}

/* 移动端适配 (481px - 768px) */
@media (max-width: 768px) {
  .banner {
    height: 400px;
  }
  
  .banner-title {
    font-size: 48px;
  }
  
  .banner-subtitle {
    font-size: 18px;
  }
  
  .service-carousel-container {
    padding: 20px 30px;
  }
  
  .card-wrapper {
    width: 50%; /* 移动端每行2个卡片 */
    min-width: 150px;
    height: 180px;
  }
  
  .nav-arrows {
    padding: 0 10px;
  }
  
  .arrow-left, .arrow-right {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }
  
  /* 资源分布图区域优化 */
  .procedure-box {
    width: 95%;
    flex-direction: column;
    gap: 15px;
  }
  
  .procedure-item {
    width: 200px;
    height: 45px;
    font-size: 20px;
    line-height: 45px;
  }
  
  .procedure-xian-box {
    display: none; /* 移动端隐藏连接线 */
  }
  
  .procedure-title-box {
    width: 95%;
    flex-direction: column;
    gap: 20px;
  }
  
  .procedure-title-items {
    width: 100%;
    flex-direction: column;
    gap: 15px;
  }
  
  .procedure-title-nr {
    width: 80%;
    margin: 0 auto;
  }
  
  .mgf20px {
    margin-left: 0;
  }
  
  .text-box {
    font-size: 16px;
  }
  
  .items-box {
    width: 60%;
    height: 45px;
    font-size: 14px;
    margin: 10px auto;
  }
  
  .mgl61 {
    margin-left: 0;
  }
  
  .process-flow-container {
    flex-direction: column;
    gap: 15px;
    margin: 20px 0;
  }
  
  .stage-container {
    width: 280px;
    height: 100px;
  }
  
  .stage-title {
    font-size: 16px;
    margin-bottom: 6px;
  }
  
  .step-item {
    font-size: 11px;
  }
  
  .step-number {
    width: 16px;
    height: 16px;
    font-size: 9px;
  }
  
  .connection-line {
    transform: rotate(90deg);
    width: 40px;
    height: 30px;
  }
  
  .category-row {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
  
  .category {
    font-size: 11px;
    padding: 6px 12px;
    min-width: 80px;
    height: 28px;
  }
  
  .fixed-sidebar {
    right: 10px;
    transform: translateY(-50%) scale(0.9);
  }
  
  .sidebar-content {
    width: 100px;
    height: 140px;
  }
  
  .text-line1, .text-line2 {
    font-size: 14px;
    letter-spacing: 0.5px;
  }
  
  .text-line3 {
    font-size: 10px;
    padding: 3px 6px;
  }
  
  .finger-pointer {
    width: 20px;
    height: 20px;
    bottom: 10px;
    right: 8px;
  }
  
  /* 小程序码响应式 - 移动端 */
  .mini-program-qr {
    width: 80px;
    height: 110px;
    right: 10px;
    top: 70%;
  }
  
  .qr-container {
    padding: 10px 8px;
  }
  
  .qr-header {
    font-size: 12px;
    margin-bottom: 6px;
  }
  
  .qr-image {
    max-width: 55px;
  }
}

/* 小屏幕适配 (320px - 480px) */
@media (max-width: 480px) {
  .banner {
    height: 300px;
  }
  
  .banner-title {
    font-size: 36px;
  }
  
  .banner-subtitle {
    font-size: 16px;
  }
  
  .service-carousel-container {
    padding: 15px 20px;
  }
  
  .card-wrapper {
    width: 100%; /* 小屏幕每行1个卡片 */
    height: 160px;
    min-width: auto;
  }
  
  .card-title {
    font-size: 12px;
    padding: 6px 10px;
  }
  
  /* 资源分布图进一步优化 */
  .procedure-item {
    width: 180px;
    height: 40px;
    font-size: 18px;
    line-height: 40px;
  }
  
  .procedure-title-nr {
    width: 90%;
  }
  
  .text-num-box {
    width: 25px;
    height: 20px;
    line-height: 20px;
    margin: auto 0px auto 15px;
  }
  
  .text-box {
    font-size: 14px;
    line-height: 40px;
  }
  
  .items-box {
    width: 70%;
    height: 40px;
    font-size: 12px;
  }
  
  .stage-container {
    width: 250px;
    height: 90px;
  }
  
  .category {
    font-size: 10px;
    padding: 5px 10px;
    min-width: 70px;
    height: 26px;
  }
  
  .fixed-sidebar {
    right: 5px;
    transform: translateY(-50%) scale(0.8);
    /* 在小屏幕上可能需要隐藏或调整位置 */
  }
  
  .sidebar-content {
    width: 90px;
    height: 120px;
  }
  
  /* 确保内容不被固定侧边栏遮挡 */
  .main-content {
    padding-right: 100px;
  }
  
  /* 小程序码响应式 - 小屏幕 */
  .mini-program-qr {
    width: 70px;
    height: 95px;
    right: 8px;
    top: 75%;
  }
  
  .qr-container {
    padding: 8px 6px;
  }
  
  .qr-header {
    font-size: 10px;
    margin-bottom: 4px;
  }
  
  .qr-image {
    max-width: 45px;
  }
}

/* 超小屏幕适配 (最小320px) */
@media (max-width: 360px) {
  .banner {
    height: 250px;
  }
  
  .banner-title {
    font-size: 28px;
  }
  
  .banner-subtitle {
    font-size: 14px;
  }
  
  .service-carousel-container {
    padding: 10px 15px;
  }
  
  .procedure-item {
    width: 160px;
    height: 35px;
    font-size: 16px;
    line-height: 35px;
  }
  
  .text-box {
    font-size: 12px;
    line-height: 35px;
  }
  
  .items-box {
    width: 80%;
    height: 35px;
    font-size: 11px;
  }
  
  /* 在超小屏幕上隐藏固定侧边栏 */
  .fixed-sidebar {
    display: none;
  }
  
  .main-content {
    padding-right: 0;
  }
  
  /* 小程序码响应式 - 超小屏幕 */
  .mini-program-qr {
    width: 60px;
    height: 85px;
    right: 5px;
    top: 80%;
  }
  
  .qr-container {
    padding: 6px 4px;
  }
  
  .qr-header {
    font-size: 9px;
    margin-bottom: 3px;
  }
  
  .qr-image {
    max-width: 40px;
  }
}
.procedure-box{
	width: 80%;
	/* height: 160px; */
	display: flex;
	margin: 0px auto;
}
.procedure-item{
	width: 170px;
	height: 50px;
	text-align: center;
	margin: 0 auto;
	font-size: 24px;
	line-height: 50px;
	border-radius: 24px;
	color: white;
	/* border: 1px red solid; */
}
.pro-img-one{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaiqian.png');
	background-size: 100% 100%;
}
.pro-img-tow{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaizhong.png');
	background-size: 100% 100%;
}
.pro-img-there{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaiho.png');
	background-size: 100% 100%;
}
.procedure-xian-box{
	width: 80%;
	/* height: 160px; */
	display: flex;
	margin:0px auto;
}
.xian-box{
	width: 370px;
	height: 35px;
	margin: 0 auto;
}
.xian-img1{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/lianjiexian1.png');
	background-size: 100% 100%;
}
.xian-img2{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/lianjiexian2.png');
	background-size: 100% 100%;
}
.xian-img3{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/lianjiexian3.png');
	background-size: 100% 100%;
}
.procedure-title-box{
	width: 80%;
	display: flex;
	margin:0px auto;
}
.procedure-title-items{
	width: 450px;
	/* height: 50px; */
	margin: 0 auto;
	display: flex;
}
.procedure-title-nr{
	width: 48%;
	display: flex;
}
.title-nr1{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaiqian1.png');
	background-size: 100% 100%;
}
.title-nr2{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaizhong2.png');
	background-size: 100% 100%;
}
.title-nr3{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaiho3.png');
	background-size: 100% 100%;
}

.mgf20px{
	margin-left: 20px;
}
.text-num-box {
	width: 30px;
    height: 25px;
    text-align: center;
    line-height: 25px;
	margin: auto 0px auto 20px;
    border-radius: 6px;
    background-color: white;
}
.text-box {
	margin-left: 5px;
    font-size: 20px;
    color: white;
    line-height:50px;
}
.items-box{
	width: 40%;
	height: 50px;
	margin-top: 20px;
	font-size: 18px;
	display: flex;
	justify-content: center; /* 水平居中 */
	align-items: center; /* 垂直居中 */
}
.mgl61{
	margin-left: 61px;
}
.items-img1-box{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/chuhaizhong3.png');
	background-size: 100% 100%;
}
.items-img2-box{
	background-image: url('https://a.hnjsxk.com/chuhaiban/website/cchuhaiho3.png');
	background-size: 100% 100%;
}

/* 政策资讯和活动发布区域样式 */
.info-activity {
  background: #f8f9fa;
  padding: 60px 0;
}

.info-activity-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  padding: 0 20px;
}

.info-module,
.activity-module {
  flex: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.module-header {
  background: white;
  color: #4A90E2;
  padding: 30px;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-section {
  text-align: left;
}

.module-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 5px 0;
  color: #4A90E2;
}

.module-subtitle {
  font-size: 12px;
  color: #999;
  margin: 0;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.more-link {
  color: #4A90E2;
  text-decoration: none;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.more-link:hover {
  color: #357ABD;
  transform: translateX(3px);
}

.more-text {
  border-bottom: 1px solid rgba(74, 144, 226, 0.5);
}

.arrow {
  font-size: 16px;
  transition: transform 0.3s ease;
}

.more-link:hover .arrow {
  transform: translateX(3px);
}

/* 政策资讯列表样式 */
.info-list {
  padding: 0;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.info-item:hover {
  background: #f8f9fa;
}

.info-item:last-child {
  border-bottom: none;
}

.info-date {
  background: #4A90E2;
  color: white;
  border-radius: 8px;
  padding: 8px 12px;
  text-align: center;
  margin-right: 20px;
  min-width: 60px;
}

.date-day {
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
}

.date-month {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 2px;
}

.info-content {
  flex: 1;
}

.info-title {
  font-size: 16px;
  color: #333;
  margin: 0;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.info-title:hover {
  color: #4A90E2;
}

/* 活动发布列表样式 */
.activity-list {
  padding: 0;
}

.activity-item {
  padding: 20px 30px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.activity-item:hover {
  background: #f8f9fa;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-content {
  width: 100%;
}

.activity-title {
  font-size: 16px;
  color: #333;
  margin: 0 0 8px 0;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.activity-title:hover {
  color: #4A90E2;
}

.activity-time {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .info-activity-container {
    flex-direction: column;
    gap: 20px;
    padding: 0 15px;
  }
  
  .module-header {
    padding: 20px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .title-section {
    width: 100%;
  }
  
  .module-title {
    font-size: 20px;
  }
  
  .more-link {
    align-self: flex-end;
  }
  
  .info-item,
  .activity-item {
    padding: 15px 20px;
  }
  
  .info-date {
    min-width: 50px;
    margin-right: 15px;
  }
  
  .date-day {
    font-size: 16px;
  }
  
  .info-title,
  .activity-title {
    font-size: 14px;
  }
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #666;
}

/* Element UI 表单样式调整 */
.modal-form .el-form-item.is-required .el-form-item__label::before {
  content: '*';
  color: #f56c6c !important;
  margin-right: 4px;
  font-weight: bold;
}

.modal-form .el-form-item.is-required .el-form-item__label::after {
  content: '' !important;
}

/* 隐藏Element UI默认的星号 */
.modal-form .el-form-item__label .el-form-item__asterisk {
  display: none !important;
}

.modal-form {
  padding: 24px;
}

.form-footer {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.service-phone {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  text-align: center;
}

.form-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

/* 模态框响应式设计 */
@media (max-width: 768px) {
  .modal-content {
    width: 95vw;
    margin: 20px;
  }
  
  .modal-form {
    padding: 16px;
  }
  
  .form-buttons {
    flex-direction: column;
  }
}

</style>